import React from 'react'
import * as XLSX from 'xlsx'
import axios from "axios";
import SweetAlert from "sweetalert2-react"; // (opcional, no usado)
import Swal from "sweetalert2";

class GetDataFromExcelJusTInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoja: "",
      hojas: [],
      file: false,
      selectedFileDocument: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  // pequeña pausa
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: value });

    if (name !== 'file') return;

    const file = target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onloadend = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const hojas = [];
        workbook.SheetNames.forEach((sheetName) => {
          const XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          hojas.push({ data: XL_row_object, sheetName });
        });

        console.log('Hojas leídas:', hojas.map(h => h.sheetName));
        const A1 = (hojas[0]?.data || []).slice(0, 1000);

        // === Subir uno por uno con pausa ===
        const delayMs = 700; // ⏱️ ajusta aquí la espera entre POST
        let ok = 0;
        let fail = 0;

        for (let i = 0; i < A1.length; i++) {
          const a = A1[i];
          try {
            await axios.post(
              `${process.env.REACT_APP_URL_CONTENEDORES}`,
              {
                fecha: "2025-11-09",
                fechaCita: "2025-10-06",
                navieras: "68e3e75af5f2d93da108ae06",
                clientes: "68e3e7f4f5f2d93da108af79",
                agentes: "68e3e9f7f5f2d93da108afa8",
                agencias: "68e3ecd6f5f2d93da108b003",
                comisionistas: "68e3ec0bf5f2d93da108aff8",
                transportistas: "68e3ebdbf5f2d93da108afec",
                forwarders: "68e3eb1af5f2d93da108afd5",
                numeroInterno: "NA",
                contenedor: a.contenedor,
                etaEstimada: a.fechaETA,
                etaReal: a.fechaETA,
                totalGastos: 0,
                totalGeneral: 0,
                totalCantidad: 0,
                observaciones: "NA",
                totalCargos: 0,
                puerto: "Lazaro Cardenas",
                puertoOrigen: "NINGBO",
                numeroBl: a.numeroBL,
                modalidad: "Camion",
                direccionEntrega: "NA",
                terminales: "659751b809da69446cc05f3d",
                programas: "65984b7d111f341061f6c353",
                patentes: "66db35dea6b7de33346cd392",
                asegurado: "No",
                rastreo: "No",
                pesoTotal: 0,
                status: "Pendiente",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );

            // Log opcional (si no quieres el burst de SweetAlerts por cada fila)
            console.log(`✔️ (${i + 1}/${A1.length}) Contenedor subido:`, a.contenedor);

            // Log en tu sistema
            try {
              await axios.post(
                process.env.REACT_APP_URL_LOGS,
                {
                  tipo: "Cargos Inicial",
                  detalle: "Cargos Inicial",
                  user: "652efcae1f73590a201faf21",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              );
            } catch (eLog) {
              console.warn('No se pudo registrar en logs para', a.contenedor, eLog);
            }

            ok++;
          } catch (error) {
            console.error(`❌ Error en fila ${i + 1} (contenedor ${a?.contenedor || 'N/A'}):`, error?.response?.data || error?.message || error);
            fail++;
          }

          // Espera entre cada POST
          await this.delay(delayMs);
        }

        // Resumen final
        Swal.fire(
          "Proceso terminado",
          `Subidos correctamente: ${ok}\nFallidos: ${fail}`,
          fail > 0 ? "warning" : "success"
        );

        this.setState({ selectedFileDocument: file, hojas });
      } catch (err) {
        console.error('Error leyendo Excel:', err);
        Swal.fire({ icon: "error", title: "Oops...", text: "Error leyendo el Excel" });
      }
    };
  }

  render() {
    const { handleInputChange } = this;

    return (
      <>
        <input
          required
          type="file"
          name="file"
          id="file"
          onChange={handleInputChange}
          placeholder="Archivo de excel"
          accept=".xlsx,.xls"
        />
      </>
    );
  }
}

export default GetDataFromExcelJusTInput;
